<template>
  <div>
    <div class="white-bg mb-4 text-right">
            <div class="p-2 overflow-hidden text-right text-gray fs-48">
              <div class="row">
                <div class=" col-6"></div>
              <div class=" col-2">
                <input type="date" v-model="obje.t1" class="form-control">
              </div>

              <div class="col-2">
                <input type="date" v-model="obje.t2" class="form-control">
              </div>

              <div class="col-2">
                <button class="btn btn-yellow btn-lg d-inline w-100 " style="height:45px; font-size:25px"  @click="getir()"> Filtrele</button>

              </div>
            </div>            
            </div>
          </div>
    <div class="col-12 p-0">
      <div class="row">
        <div class="col-md-6 p-0">
          <div class="white-bg px-2 py-3 relative">
            <h2 class="h2">Ziyaretler</h2>

            <table class="table">
              <thead>
                <tr class="bg-light">
                  <th>Sebebi</th>
                  <th>Kullanıcı</th>
                  <th>Müşteri</th>
                  <th>Güncelleme</th>
                  <th>Bilgi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in posts" :key="index">

                  <td>{{ item.sebebi }}</td>
                  <td>{{ item.ad }}</td>
                  <td>{{ item.baslik }}</td>
                  <td>{{$helper.trtgoster(item.guncelleme)  }}</td>
                  <td class="text-center"><a style="font-size:21px; font-weight: bold;" class="flaticon-next" href="javascript:void(0)" @click="opendetail(index)"></a></td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="col-md-6">
          <div class="row" v-if="detail" >
            <div class="col-12">
              <div class="white-bg p-3">
                <h2 class="h2">Ziyaret Detayı</h2>
                <textarea class="form-control" v-model="openDetay"  :readonly="read" rows="10"></textarea>
              </div>
            </div>
            <div class="col-6 text-center">
              <div class="p-3">
                <button @click="detayekle()" class="btn btn-orange btn-sm text-center d-block w-100" style="height:55px"><span class="fs13">KİLİDİ KALDIR</span></button></div>
              </div>
              <div class="col-6 text-center">
              <div class="p-3">
                <button @click="guncelle()" class="btn btn-blue btn-sm text-center d-block w-100" style="height:55px"><span class="fs13">GÜNCELLE</span></button></div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      posts:[],
      hesap:this.$store.getters.getHesap,
      detail:false,
      read:true,
      obje : {
        root: this.$store.getters.getHesap.root,
        kid: this.$store.getters.getHesap.kid,
        entegrekodu: this.$store.getters.getHesap.entegrekodu, // personel mi müşterimi hesaplama için
        ckod: this.$store.getters.getCari.aktif.kod,
        t1: new Date().getFullYear() + ".01.01",
        t2: this.$helper.trtgosternoktali(new Date() + 1),
      },
      openDetay : '',
      secili:0
    };
  },
  created() {
    //this.masrafGetir();
    this.getir();
    this.$store.commit("setLoading",[true,'Bekleyiniz'])

  },
  methods: {
    getir() {
      this.$store.commit("setLoading",[true,'Bekleyiniz'])

      this.$request.post("crm/planlama/liste/", this.obje,this.hesap).then((response) => {
      this.posts = response.data;
      this.$store.commit("setLoading",[false,'...'])
    });
    },
    opendetail(index){
      this.secili = index
      this.detail = true
      this.openDetay = this.posts[index].text

    },
    detayekle(event){
        this.read=false
        this.openDetay+=" ------------------------- "+this.obje.t2+" ------------------------"

    },
    guncelle() {
      this.$store.commit("setLoading",[true,'Bekleyiniz'])

      this.$request.post("crm/planlama/update/", {id:this.posts[this.secili].id, text:this.openDetay,names:this.hesap.kad},this.hesap).then((response) => {
      this.$store.commit("setLoading",[false,'...'])
      this.$swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Güncelleme Başarılı",
                  showConfirmButton: false,
                  timer: 2000,
                });
    });
    },

  },
};
</script>

<style scoped>
.btn {font-size:45px !important}

</style>


// WEBPACK FOOTER //
// src/views/plan.vue